/* Mock data for PrepMate (Austin) */

export const CITY = {
  name: "Austin",
  state: "TX",
  label: "Austin, TX"
};

export const DIETS = [
  { id: "standard", label: "Standard" },
  { id: "vegan", label: "Vegan" },
  { id: "gluten-free", label: "Gluten-free" },
  { id: "low-carb", label: "Low-carb" },
  { id: "high-protein", label: "High-protein" }
];

export const SUBSCRIPTIONS = [
  { id: "sub-1", meals: 1, label: "1 meal / week", cadence: "weekly", priceMultiplier: 1 },
  { id: "sub-5", meals: 5, label: "5 meals / week", cadence: "weekly", priceMultiplier: 4.8 },
  { id: "sub-10", meals: 10, label: "10 meals / week", cadence: "weekly", priceMultiplier: 9.3 },
  { id: "sub-15", meals: 15, label: "15 meals / week", cadence: "weekly", priceMultiplier: 13.5 }
];

// Imagery curated (neutral, stock, no faces)
const IMG = {
  prep1: "https://images.unsplash.com/photo-1667499745120-f9bcef8f584e?crop=entropy&cs=srgb&fm=jpg&q=85",
  prep2: "https://images.pexels.com/photos/30635717/pexels-photo-30635717.jpeg",
  prep3: "https://images.pexels.com/photos/30635719/pexels-photo-30635719.jpeg",
  prep4: "https://images.unsplash.com/photo-1668838289210-e7665d947145?crop=entropy&cs=srgb&fm=jpg&q=85",
  bowl1: "https://images.unsplash.com/photo-1640718153998-e1f918e2ba6a?crop=entropy&cs=srgb&fm=jpg&q=85",
  bowl2: "https://images.unsplash.com/photo-1674316037121-5210009059f5?crop=entropy&cs=srgb&fm=jpg&q=85",
  bowl3: "https://images.pexels.com/photos/7902939/pexels-photo-7902939.jpeg",
  bowl4: "https://images.pexels.com/photos/1640770/pexels-photo-1640770.jpeg",
  salad1: "https://images.unsplash.com/photo-1604909052743-94e838986d24?crop=entropy&cs=srgb&fm=jpg&q=85",
  salad2: "https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?crop=entropy&cs=srgb&fm=jpg&q=85",
  salad3: "https://images.unsplash.com/photo-1682423187670-4817da9a1b23?crop=entropy&cs=srgb&fm=jpg&q=85",
  salad4: "https://images.unsplash.com/photo-1582034986517-30d163aa1da9?crop=entropy&cs=srgb&fm=jpg&q=85"
};

export const VENDORS = [
  {
    id: "v-austin-01",
    name: "ATX Fresh Prep",
    cuisines: ["American", "Healthy"],
    diets: ["standard", "high-protein", "low-carb"],
    rating: 4.8,
    reviews: 214,
    eta: "30-45 min",
    delivery: ["weekly", "pickup"],
    image: IMG.prep1,
    fee: "$2.99",
    menu: [
      {
        id: "m-a1",
        name: "Grilled Chicken Macro Bowl",
        desc: "Grilled chicken, quinoa, greens, roasted veggies, lemon tahini.",
        price: 12.0,
        image: IMG.salad1,
        dietTags: ["high-protein", "gluten-free"]
      },
      {
        id: "m-a2",
        name: "Low-Carb Steak & Greens",
        desc: "Flank steak, arugula, cherry tomatoes, pesto.",
        price: 14.5,
        image: IMG.salad2,
        dietTags: ["low-carb", "high-protein"]
      }
    ],
    recentReviews: [
      { user: "Maya", stars: 5, text: "Super fresh and perfectly seasoned." },
      { user: "Chris", stars: 5, text: "Macros on point. Great for bulk week." }
    ]
  },
  {
    id: "v-austin-02",
    name: "Barton Bowls",
    cuisines: ["Bowls", "Vegetarian"],
    diets: ["vegan", "gluten-free", "standard"],
    rating: 4.7,
    reviews: 168,
    eta: "25-35 min",
    delivery: ["weekly", "pickup"],
    image: IMG.bowl1,
    fee: "$1.99",
    menu: [
      {
        id: "m-b1",
        name: "Vegan Power Bowl",
        desc: "Tofu, brown rice, kale, edamame, sesame ginger.",
        price: 11.5,
        image: IMG.bowl2,
        dietTags: ["vegan", "gluten-free"]
      },
      {
        id: "m-b2",
        name: "South Congress Southwest",
        desc: "Black beans, corn, peppers, avocado, lime crema (vegan).",
        price: 10.5,
        image: IMG.bowl3,
        dietTags: ["vegan", "standard"]
      }
    ],
    recentReviews: [
      { user: "Tina", stars: 5, text: "Best vegan bowls in Austin." },
      { user: "Jordan", stars: 4, text: "Loved the dressings and portions." }
    ]
  },
  {
    id: "v-austin-03",
    name: "512 Meal Co.",
    cuisines: ["Meal Prep", "American"],
    diets: ["standard", "high-protein"],
    rating: 4.6,
    reviews: 302,
    eta: "35-50 min",
    delivery: ["weekly", "pickup"],
    image: IMG.prep2,
    fee: "$3.49",
    menu: [
      {
        id: "m-c1",
        name: "BBQ Chicken & Sweet Potato",
        desc: "Smoky BBQ chicken, mashed sweet potato, green beans.",
        price: 12.5,
        image: IMG.salad3,
        dietTags: ["standard", "high-protein"]
      },
      {
        id: "m-c2",
        name: "Turkey Meatballs Marinara",
        desc: "Lean turkey, marinara, zucchini noodles.",
        price: 13.0,
        image: IMG.salad4,
        dietTags: ["gluten-free", "low-carb"]
      }
    ],
    recentReviews: [
      { user: "Ari", stars: 5, text: "Hearty and well-balanced meals." },
      { user: "Sam", stars: 4, text: "Great variety each week." }
    ]
  },
  {
    id: "v-austin-04",
    name: "Zilker Greens",
    cuisines: ["Salads", "Healthy"],
    diets: ["gluten-free", "standard"],
    rating: 4.5,
    reviews: 98,
    eta: "20-30 min",
    delivery: ["weekly", "pickup"],
    image: IMG.prep3,
    fee: "$1.49",
    menu: [
      {
        id: "m-d1",
        name: "Caesar Light",
        desc: "Romaine, parmesan, light dressing; optional chicken.",
        price: 9.5,
        image: IMG.bowl4,
        dietTags: ["standard"]
      }
    ],
    recentReviews: [
      { user: "Dev", stars: 5, text: "Crisp greens, great packaging." }
    ]
  },
  {
    id: "v-austin-05",
    name: "Congress Kitchen Prep",
    cuisines: ["American", "Protein"],
    diets: ["high-protein", "low-carb"],
    rating: 4.9,
    reviews: 410,
    eta: "30-40 min",
    delivery: ["weekly", "pickup"],
    image: IMG.prep4,
    fee: "$2.49",
    menu: [
      {
        id: "m-e1",
        name: "Steak & Veg Medley",
        desc: "Seared steak, mixed veg, herb butter.",
        price: 15.0,
        image: IMG.salad2,
        dietTags: ["high-protein", "low-carb"]
      }
    ],
    recentReviews: [
      { user: "Nina", stars: 5, text: "Premium quality and flavors." }
    ]
  },
  {
    id: "v-austin-06",
    name: "Eastside Prep House",
    cuisines: ["Meal Prep", "Fusion"],
    diets: ["standard", "vegan"],
    rating: 4.4,
    reviews: 153,
    eta: "30-45 min",
    delivery: ["weekly", "pickup"],
    image: IMG.bowl2,
    fee: "$1.99",
    menu: [
      {
        id: "m-f1",
        name: "Tofu Teriyaki Bowl",
        desc: "Tofu, rice, broccoli, teriyaki glaze.",
        price: 10.0,
        image: IMG.bowl1,
        dietTags: ["vegan", "standard"]
      }
    ],
    recentReviews: [
      { user: "Owen", stars: 4, text: "Solid weekly staple." }
    ]
  }
];

export const CUSTOMIZATION_OPTIONS = [
  { id: "no-onions", label: "No onions", type: "toggle", fee: 0 },
  { id: "no-pickles", label: "No pickles", type: "toggle", fee: 0 },
  { id: "no-peppers", label: "No peppers", type: "toggle", fee: 0 },
  { id: "extra-protein", label: "Extra protein (+$2.00)", type: "toggle", fee: 2 },
  { id: "no-sauce", label: "No sauce", type: "toggle", fee: 0 },
  { id: "sauce-side", label: "Sauce on the side", type: "toggle", fee: 0 }
];

export const DEFAULT_USER = {
  isAuthed: false,
  role: "customer", // or "company"
  name: "",
  email: ""
};